<!--
 * Created by JackCui on 2021/12/13
 -->

<script>
  import emitter from '../utils/emitter.js'
  import { isFunction, isUndefined } from 'lodash-es'
  const i18n = {
    'zh-CN': {operation: '操作'},
    'en': {operation: 'Operation'}
  }
  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'table-render',
    props: {
      node: Object
    },
    data () {
      return {
        tableSelection: [],
        pagination: {
          pageSizes: [10, 20, 50, 100],
          pageSize: 10,
          page: 1,
          total: (this.curFormData || []).length
        },
        customColumn: {}
      }
    },
    mixins: [emitter],
    inject: ['formData', 'subData', 'store'],
    computed: {
      componentName () {
        if (this.integrationConfig.tableComponentName === 'group') {
          return 'FeVirtualGroupTable'
        }
        return this.groupRowKey ? 'FeGroupTable' : 'FeTable'
      },
      curFormData () {
        // 筛选条件
        const filterFn = this.node.filterFn
        const arr = this.subData || this.formData || []
        return filterFn ? arr.filter(filterFn) : arr
      },
      columns () {
        const {
          viewContent,
          inlineButtons,
          slots = {}
        } = this.node
        let enableOperationColumn = this.node.enableOperationColumn
        const columns = viewContent
          .filter(v => {
            let {hide} = v
            if (typeof hide === 'function') {
              hide = hide({
                column: v,
                formData: this.curFormData
              })
            }
            // 记录当前列的状态
            this.$set(v, 'columnShow', !hide)
            return !hide
          })
          .map(v => {
            const {info: {name, apiName, locked, width}, viewContent, slots = {}, className} = v
            return {
              title: (cell) => this.renderHeaderCell(name, cell, slots),
              dataIndex: apiName,
              fixed: locked,
              width,
              className,
              customRender: (payload) => this.renderTBodyCell(payload, viewContent, slots)
            }
          })

        // 处理自定义列的数据
        for (let k in this.customColumn) {
          let idx = columns.findIndex(v => v.dataIndex === k)
          if (idx >= 0) {
            columns.splice(idx + 1, 0, ...this.customColumn[k])
            // delete this.customColumn[k]
          }
        }

        if (this.showSelection) {
          columns.unshift(this.selectionRender())
        }
        if (isFunction(enableOperationColumn)) {
          enableOperationColumn = enableOperationColumn()
        }
        if (enableOperationColumn && inlineButtons.length) {
          columns.push(this.operationRender(inlineButtons))
        }
        if (slots.row_expand) {
          columns.push({type: 'expand', customRender: (payload) => slots.row_expand(this.$createElement, payload)})
        }
        return columns
      },
      selectionFixed () {
        return this.node.viewContent.some(v => v.info?.locked)
      },
      showSelection () {
        const {showSelection, batchButtons} = this.node
        const batch = (batchButtons || []).find(item => {
          if (item.type === 'button_group') {
            return item.buttonList.find(btn => btn.supportBatch)
          }
          return item.supportBatch
        })
        let _showSelection = showSelection

        if (isFunction(_showSelection)) {
          _showSelection = _showSelection()
        }

        return isUndefined(_showSelection) ? batch : _showSelection
      },
      selectType () {
        return this.node.selectType || 'checkbox'
      },
      rowKey () {
        return this.node?.rowKey || 'aPaaS_SequenceId'
      },
      groupRowKey () {
        let _groupRowKey = this.node?.groupRowKey
        if (isFunction(_groupRowKey)) {
          return _groupRowKey()
        }
        return _groupRowKey
      },
      groupKey () {
        let _groupKey = this.node?.groupKey
        if (isFunction(_groupKey)) {
          return _groupKey()
        }
        return _groupKey
      },
      dPagination () {
        // 当前页面配置信息
        let pagination = this.store.queryParams || this.node.pagination || this.pagination
        if (isFunction(pagination)) {
          pagination = pagination()
        }

        // 计算总数
        let {total, pageSize, page} = pagination
        if (isFunction(this.node.total)) {
          total = this.node.total()
        }

        // 更新最后页的总页数
        const totalPage = Math.ceil(total / pageSize)
        if (total && totalPage < page) {
          pagination.page = totalPage
          this.handlePageChange()
        }
        // 更新总数
        this.$set(pagination, 'total', total)
        return pagination
      },
      showPaginationOpt () {
        return !(this.node.showPaginationOpt === false) && this.dPagination.total > 10
      },
      selfPaging () {
        return !!this.subData && !this.node.fetchData
      },
      selectedCount () {
        let _showSelectedCount = this.node.showSelectedCount
        if (isFunction(_showSelectedCount)) {
          _showSelectedCount = _showSelectedCount()
        }
        return _showSelectedCount ? this.tableSelection.length : 0
      },
      defaultExpandAll () {
        const defaultExpandAll = this.node.defaultExpandAll
        return isFunction(defaultExpandAll) ? defaultExpandall() : defaultExpandAll
      },
      forceExpand () {
        const forceExpand = this.node.forceExpand
        return isFunction(forceExpand) ? forceExpand() : forceExpand
      },
      integrationConfig () {
        return this.node.integrationConfig || {}
      }
    },
    render () {
      let groupHeight = null
      if (this.integrationConfig.grouping) {
        groupHeight = {
          group: this.integrationConfig.groupMaxHeight
        }
      }
      return (
        <div>
          {this.renderFiltrateArea()}
          <sy-table
            ref='syTable'
            isOpenAllCheck={this.node.isOpenAllCheck}
            changeAll={this.node.changeAll}
            showGroupError={this.node.showGroupError}
            tableComponentName={this.integrationConfig.tableComponentName}
            defaultExpandAll={this.defaultExpandAll}
            forceExpand={this.forceExpand}
            groupRowKey={this.groupRowKey}
            groupKey={this.groupKey}
            columns={this.columns}
            componentName={this.componentName}
            selectedCount={this.selectedCount}
            selfPaging={this.selfPaging}
            paginationOpt={this.dPagination}
            showPaginationOpt={this.showPaginationOpt}
            data={this.curFormData}
            rowKey={this.rowKey}
            on-page-change={this.handlePageChange}
            scopedSlots={{
              groupTitle: this.renderGroupTitle(),
              groupError: this.renderError()
            }}
            groupHeight={groupHeight}
          >
          </sy-table>
        </div>
      )
    },
    methods: {
      renderGroupTitle () {
        const { grouping, integrationGroups } = this.integrationConfig
        if (this.groupRowKey || grouping) {
          let groupTitle = this.node.slots?.['group_title']
          if (groupTitle) {
            return (...arg) => {
              return groupTitle(...arg, integrationGroups)
            }
          }
          return (_, { record }) => {
            return  <div class="list-group-title">
            {integrationGroups.map((integration) => {
              return (
                <div class="group-title-cell">
                  {!integration.props.hideLabel && <span class='group-title-label'>{integration.name}:</span>}
                  <span class='group-title-value'>{record[integration.apiName]}</span>
                </div>
              )
            })}
          </div> 
          }
        }
        return null
      },
      renderError () {
        const errorSlot = this.node.slots?.['group_error']
        if (!errorSlot) {
          return null
        }
        return errorSlot
      },
      renderFiltrateArea () {
        const filtrateAreaFn = this.node.slots?.['filtrate_area']
        return filtrateAreaFn ? filtrateAreaFn(this.$createElement) : null
      },
      handlePageChange (page) {
        if (this.node.fetchData) {
          return this.node.fetchData(this.dPagination)
        }
        if (this.store && this.store._changePage) {
          this.store._changePage(page)
        }
        if (isFunction(this.node?.changePage)) {
          this.node.changePage(page)
        }
      },
      getIndex (row, $index) {
        const arr = this.subData || this.formData
        const _idx = arr.findIndex(item => item[this.rowKey] === row[this.rowKey])
        return _idx > -1 ? _idx : $index
      },
      renderTBodyCell ({row, column, $index, groupIndex}, viewContent, slots = {}) {
        const cell = []
        // const {page, pageSize} = this.dPagination
        this.slotsHandle(cell, slots, 'content_before', {row, column, $index})
        // this.selfPaging ? $index + ((page - 1) * pageSize) : $index
        if (!this.slotsHandle(cell, slots, 'content', {row, column, $index})) {
          cell.push(
            <render
              class={{'plain-table-item': this.node.pageType === 'list' || this.node.pageType === 'detail'}}
              viewContent={viewContent}
              attrs={{
                // TODO 从对象中由于前端分页 form-item 的prop索引需要根据页码计算
                groupProp: typeof groupIndex === 'number' ? `${groupIndex}.${this.groupKey}` : '',
                rowIndex: this.getIndex(row, $index),
                row
              }}
            />
          )
        }
        this.slotsHandle(cell, slots, 'content_after', {row, column, $index})
        return cell
      },
      renderHeaderCell (title, column, slots = {}) {
        const cell = []
        this.slotsHandle(cell, slots, 'header_before', column)
        if (!this.slotsHandle(cell, slots, 'header', column)) {
          cell.push(title)
        }
        this.slotsHandle(cell, slots, 'header_after', column)
        return cell
      },
      slotsHandle (cell, slots, position, props) {
        const slotsFn = slots?.[position]
        if (slotsFn) {
          cell.push(slotsFn(this.$createElement, props))
          return true
        }
        return false
      },
      handleSelectionChange (row, keys) {
        this.tableSelection = row
        if (isFunction(this.node.selectionChange)) {
          this.node.selectionChange(row, keys)
        }
        this.dispatch('page-list', 'selection-change', row)
      },
      selectionRender () {
        return {
          width: '55',
          type: 'selection',
          fixed: this.selectionFixed,
          selectType: this.selectType,
          selectTip: this.node.selectTip,
          selectable: this.node.selectable,
          reserveSelection: this.node.reserveSelection,
          selectionChange: this.handleSelectionChange
        }
      },
      operationRender (buttons) {
        const node = {
          position: 'vertical',
          maxLength: this.node.inlineButtonShowQuantity || '5',
          buttons
        }
        return {
          title: pageText.operation,
          key: 'operation',
          width: 110,
          align: 'center',
          fixed: 'right',
          customRender: ({row, column, $index}) => {
            return (
              <buttons-render
                node={node}
                row={row}
              />
            )
          }
        }
      },
      toggleSelection (row, flag) {
        this.$refs['syTable'].toggleSelection(row, flag)
      },
      toggleRowExpansion (row, flag) {
        this.$refs['syTable'].toggleRowExpansion(row, flag)
      },
      addColumn (position, items) {
        if (this.customColumn[position]) {
          this.customColumn[position].push(...items)
        } else {
          this.$set(this.customColumn, position, items)
        }
      },
      delColumn (columnId) {
        const columnIdx = this.columns.findIndex(v => v.dataIndex === columnId)
        if (columnIdx >= 0) {
          this.$set(this.columns[columnIdx], 'hide', true)
        }
      },
      updatePageByIndex (idx) {
        const {page, pageSize} = this.dPagination
        const newPage = Math.ceil((idx + 1) / pageSize)
        if (page === newPage) return
        this.$set(this.dPagination, 'page', newPage)
      }
    },
    mounted () {
      this.store.saveRef(`table`, this)
    }
  }
</script>
<style scoped lang='scss'>
.plain-table-item{
  ::v-deep .sy-form-item {
    .el-form-item {
      .el-form-item__label{
        padding-top: 0;
      }
    }
    
    .el-form-item__content .field.field-mini.is-pure-text{
      padding-top: 0;
    }
    .follow-conent .field.field-mini.is-pure-text{
      padding-top: 0;
    }
  }
}
::v-deep .sy-table-body-cell > .render > .sy-form-item:last-child{
  padding: 0;
}
::v-deep .sy-table-body-cell > .render > .sy-form-item .is-pure-text{
  // padding: 0;
}
.list-group-title {
  background: #f9f9f9;
  padding: 0 10px;
  height: 100%;
  .group-title-cell{
    display: inline-block;
    width: 178px;
    margin-right: 20px;
  }
}
</style>
